"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryParams = exports.fromQueryParams = exports.Objects = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
let Objects = class Objects {
    static fromQueryParams(options) {
        const searchParams = new URLSearchParams(options.query);
        return Object.fromEntries(searchParams.entries());
    }
    static toQueryParams(options) {
        const { excludeKeys = [], includeKeys = [], params, sortKeys = false, urlEncode = false } = options;
        const filteredParams = Object.keys(params).reduce((acc, key) => {
            if (includeKeys.length && !includeKeys.includes(key))
                return acc;
            if (excludeKeys.includes(key))
                return acc;
            acc[key] = params[key];
            return acc;
        }, {});
        const searchParams = new URLSearchParams(sortKeys ? Object.entries(filteredParams).sort(([a], [b]) => a.localeCompare(b)) : filteredParams);
        const queryString = searchParams.toString();
        return urlEncode ? encodeURIComponent(queryString) : queryString;
    }
};
exports.Objects = Objects;
exports.Objects = Objects = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], Objects);
exports.fromQueryParams = Objects.fromQueryParams, exports.toQueryParams = Objects.toQueryParams;
//# sourceMappingURL=objects.js.map